exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropzone-container {\n  padding: 3rem;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.file-dropzone {\n  border: 1px #ccc dashed;\n  width: 50%;\n  padding: 5rem 3rem; }\n\n.errorContainer {\n  width: 50%; }\n\n.button-wrapper {\n  text-align: center; }\n\n.error-panel {\n  width: 50%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/manage/common/drop-zone/DropZone.scss
// module id = 1367
// module chunks = 0